//
//
//
//
import ExceptionPage from "./ExceptionPage";
export default {
  components: {
    ExceptionPage: ExceptionPage
  }
};